module.exports = "<div class=\"overlay\" *ngIf=\"showLoader\">\r\n  <div class=\"loader\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/component/loader/loader.component.html
// module id = ../../../../../src/app/component/loader/loader.component.html
// module chunks = main